import { ExperienceRecord } from '../types/experience'

export const mockExperiences: ExperienceRecord[] = [
  {
    Id: 'exp-001',
    Name: 'EXP-004192',
    CreatedDate: '2023-10-15T14:30:00Z',
    Opportunity__c: 'OPP-2024-0142 - 847 Maple Ave Fix & Flip',
    Guarantor__c: 'James Harrington',
    Total_Experience__c: 12,
    Experience_Tier__c: '5+',
    Experience_Notes__c:
      'Borrower has extensive experience in the local market. Primary focus on single-family rehabs. Has completed 3 projects in the last 12 months.',
    Transactions_Cumulative_Sale_Price__c: 4500000,
    Transactions_Average_Sales_Price__c: 375000,
    Transactions_Average_Project_Duration__c: 5.5,
    Number_of_Flips__c: 10,
    Fix_Flip_Cumulative_Sale_Price__c: 3800000,
    Fix_Flip_Average_Sale_Price__c: 380000,
    Fix_Flip_Average_Project_Duration__c: 5.2,
    Number_of_New_Builds__c: 2,
    New_Construction_Cumulative_Sale_Price__c: 700000,
    New_Construction_Average_Sale_Price__c: 350000,
    New_Construction_Avg_Project_Duration__c: 8.0,
    Number_of_GC_Projects__c: 0,
    Average_Rehab_Budget__c: 45000,
    Max_Rehab_Budget__c: 65000,
    Average_GC_Budget__c: null,
    Max_GC_Budget__c: null,
    Average_Construction_Budget__c: 120000,
    Max_Construction_Budget__c: 150000,
    verificationStatus: 'pending',
    underwriterNotes: '',
    individualExperiences: [
      {
        Id: 'iexp-001-1',
        Name: 'IEXP-004192-1',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '123 Oak St',
          city: 'Springfield',
          state: 'IL',
          zip: '62704',
        },
        Units__c: 1,
        Entity_Name__c: 'Harrington Properties LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 150000,
        Purchase_Date__c: '2022-01-15',
        Sale_Price__c: 280000,
        Sale_Date__c: '2022-07-20',
        Rehab_Amount__c: 45000,
        Net_Profit__c: 85000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-001-2',
        Name: 'IEXP-004192-2',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '456 Maple Ave',
          city: 'Springfield',
          state: 'IL',
          zip: '62704',
        },
        Units__c: 1,
        Entity_Name__c: 'Harrington Properties LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 180000,
        Purchase_Date__c: '2022-03-10',
        Sale_Price__c: 310000,
        Sale_Date__c: '2022-09-15',
        Rehab_Amount__c: 55000,
        Net_Profit__c: 75000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-001-3',
        Name: 'IEXP-004192-3',
        Experience_Type__c: 'New Construction',
        Property_Address__c: {
          street: '789 Pine Ln',
          city: 'Chatham',
          state: 'IL',
          zip: '62629',
        },
        Units__c: 1,
        Entity_Name__c: 'Harrington Properties LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 45000,
        Purchase_Date__c: '2022-06-01',
        Sale_Price__c: 350000,
        Sale_Date__c: '2023-02-28',
        Rehab_Amount__c: 150000,
        Net_Profit__c: 155000,
        Rehab_Flag__c: false,
        Construction_Flag__c: true,
        Status__c: 'Completed',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-001-4',
        Name: 'IEXP-004192-4',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '321 Elm St',
          city: 'Springfield',
          state: 'IL',
          zip: '62703',
        },
        Units__c: 2,
        Entity_Name__c: 'Harrington Properties LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 120000,
        Purchase_Date__c: '2023-01-05',
        Sale_Price__c: 250000,
        Sale_Date__c: '2023-06-10',
        Rehab_Amount__c: 60000,
        Net_Profit__c: 70000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: false,
      },
      {
        Id: 'iexp-001-5',
        Name: 'IEXP-004192-5',
        Experience_Type__c: 'New Construction',
        Property_Address__c: {
          street: '101 Cedar Dr',
          city: 'Chatham',
          state: 'IL',
          zip: '62629',
        },
        Units__c: 1,
        Entity_Name__c: 'Harrington Properties LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 50000,
        Purchase_Date__c: '2023-02-15',
        Sale_Price__c: 360000,
        Sale_Date__c: null,
        Rehab_Amount__c: 160000,
        Net_Profit__c: null,
        Rehab_Flag__c: false,
        Construction_Flag__c: true,
        Status__c: 'In Progress',
        Exit_Type__c: null,
        Verified_Flag__c: false,
      },
    ],
  },
  {
    Id: 'exp-002',
    Name: 'EXP-004193',
    CreatedDate: '2023-10-16T09:15:00Z',
    Opportunity__c: 'OPP-2024-0145 - 2204 Oak St New Construction',
    Guarantor__c: 'Maria Chen',
    Total_Experience__c: 3,
    Experience_Tier__c: '3-4',
    Experience_Notes__c:
      'Newer investor, transitioning from rental portfolio to flips. Partnering with experienced GC.',
    Transactions_Cumulative_Sale_Price__c: 850000,
    Transactions_Average_Sales_Price__c: 283333,
    Transactions_Average_Project_Duration__c: 6.0,
    Number_of_Flips__c: 3,
    Fix_Flip_Cumulative_Sale_Price__c: 850000,
    Fix_Flip_Average_Sale_Price__c: 283333,
    Fix_Flip_Average_Project_Duration__c: 6.0,
    Number_of_New_Builds__c: 0,
    New_Construction_Cumulative_Sale_Price__c: null,
    New_Construction_Average_Sale_Price__c: null,
    New_Construction_Avg_Project_Duration__c: null,
    Number_of_GC_Projects__c: 0,
    Average_Rehab_Budget__c: 30000,
    Max_Rehab_Budget__c: 35000,
    Average_GC_Budget__c: null,
    Max_GC_Budget__c: null,
    Average_Construction_Budget__c: null,
    Max_Construction_Budget__c: null,
    verificationStatus: 'pending',
    underwriterNotes: '',
    individualExperiences: [
      {
        Id: 'iexp-002-1',
        Name: 'IEXP-004193-1',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '555 Birch St',
          city: 'Columbus',
          state: 'OH',
          zip: '43215',
        },
        Units__c: 1,
        Entity_Name__c: 'Chen Investments LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 180000,
        Purchase_Date__c: '2022-05-10',
        Sale_Price__c: 275000,
        Sale_Date__c: '2022-10-15',
        Rehab_Amount__c: 35000,
        Net_Profit__c: 60000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-002-2',
        Name: 'IEXP-004193-2',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '888 Walnut Ave',
          city: 'Columbus',
          state: 'OH',
          zip: '43215',
        },
        Units__c: 1,
        Entity_Name__c: 'Chen Investments LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 195000,
        Purchase_Date__c: '2022-08-01',
        Sale_Price__c: 290000,
        Sale_Date__c: '2023-01-20',
        Rehab_Amount__c: 30000,
        Net_Profit__c: 65000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-002-3',
        Name: 'IEXP-004193-3',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '222 Cherry Ln',
          city: 'Columbus',
          state: 'OH',
          zip: '43215',
        },
        Units__c: 1,
        Entity_Name__c: 'Chen Investments LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 200000,
        Purchase_Date__c: '2023-02-15',
        Sale_Price__c: 285000,
        Sale_Date__c: '2023-07-30',
        Rehab_Amount__c: 25000,
        Net_Profit__c: 60000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: false,
      },
    ],
  },
  {
    Id: 'exp-003',
    Name: 'EXP-004195',
    CreatedDate: '2023-10-16T11:45:00Z',
    Opportunity__c: 'OPP-2024-0150 - 1500 Sunset Blvd Commercial',
    Guarantor__c: 'Robert Okafor',
    Total_Experience__c: 25,
    Experience_Tier__c: '5+',
    Experience_Notes__c:
      'High net worth individual with significant commercial development experience. Moving into residential flips for diversification.',
    Transactions_Cumulative_Sale_Price__c: 12500000,
    Transactions_Average_Sales_Price__c: 500000,
    Transactions_Average_Project_Duration__c: 12.0,
    Number_of_Flips__c: 5,
    Fix_Flip_Cumulative_Sale_Price__c: 2500000,
    Fix_Flip_Average_Sale_Price__c: 500000,
    Fix_Flip_Average_Project_Duration__c: 6.0,
    Number_of_New_Builds__c: 20,
    New_Construction_Cumulative_Sale_Price__c: 10000000,
    New_Construction_Average_Sale_Price__c: 500000,
    New_Construction_Avg_Project_Duration__c: 14.0,
    Number_of_GC_Projects__c: 5,
    Average_Rehab_Budget__c: 80000,
    Max_Rehab_Budget__c: 120000,
    Average_GC_Budget__c: 200000,
    Max_GC_Budget__c: 500000,
    Average_Construction_Budget__c: 250000,
    Max_Construction_Budget__c: 400000,
    verificationStatus: 'verified',
    underwriterNotes: 'Verified based on previous deal history with the bank.',
    individualExperiences: [
      {
        Id: 'iexp-003-1',
        Name: 'IEXP-004195-1',
        Experience_Type__c: 'New Construction',
        Property_Address__c: {
          street: '1000 Sunset Blvd',
          city: 'Los Angeles',
          state: 'CA',
          zip: '90026',
        },
        Units__c: 4,
        Entity_Name__c: 'Okafor Development Group',
        Ownership_Pct__c: 50,
        Purchase_Price__c: 800000,
        Purchase_Date__c: '2020-01-10',
        Sale_Price__c: 2200000,
        Sale_Date__c: '2021-06-15',
        Rehab_Amount__c: 900000,
        Net_Profit__c: 500000,
        Rehab_Flag__c: false,
        Construction_Flag__c: true,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-003-2',
        Name: 'IEXP-004195-2',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '2500 Wilshire Blvd',
          city: 'Santa Monica',
          state: 'CA',
          zip: '90403',
        },
        Units__c: 1,
        Entity_Name__c: 'Okafor Development Group',
        Ownership_Pct__c: 75,
        Purchase_Price__c: 1200000,
        Purchase_Date__c: '2021-08-20',
        Sale_Price__c: 1800000,
        Sale_Date__c: '2022-04-10',
        Rehab_Amount__c: 200000,
        Net_Profit__c: 400000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-003-3',
        Name: 'IEXP-004195-3',
        Experience_Type__c: 'New Construction',
        Property_Address__c: {
          street: '500 Ocean Ave',
          city: 'Santa Monica',
          state: 'CA',
          zip: '90401',
        },
        Units__c: 2,
        Entity_Name__c: 'Okafor Development Group',
        Ownership_Pct__c: 50,
        Purchase_Price__c: 1500000,
        Purchase_Date__c: '2022-01-15',
        Sale_Price__c: 3500000,
        Sale_Date__c: '2023-05-20',
        Rehab_Amount__c: 1200000,
        Net_Profit__c: 800000,
        Rehab_Flag__c: false,
        Construction_Flag__c: true,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-003-4',
        Name: 'IEXP-004195-4',
        Experience_Type__c: 'Construction',
        Property_Address__c: {
          street: '123 Main St',
          city: 'Los Angeles',
          state: 'CA',
          zip: '90012',
        },
        Units__c: 1,
        Entity_Name__c: 'Okafor Development Group',
        Ownership_Pct__c: 100,
        Purchase_Price__c: null,
        Purchase_Date__c: '2023-01-10',
        Sale_Price__c: null,
        Sale_Date__c: '2023-08-15',
        Rehab_Amount__c: 450000,
        Net_Profit__c: null,
        Rehab_Flag__c: false,
        Construction_Flag__c: true,
        Status__c: 'Completed',
        Exit_Type__c: null,
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-003-5',
        Name: 'IEXP-004195-5',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '789 Hill St',
          city: 'Los Angeles',
          state: 'CA',
          zip: '90014',
        },
        Units__c: 1,
        Entity_Name__c: 'Okafor Development Group',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 900000,
        Purchase_Date__c: '2023-03-01',
        Sale_Price__c: 1300000,
        Sale_Date__c: null,
        Rehab_Amount__c: 150000,
        Net_Profit__c: null,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'In Progress',
        Exit_Type__c: null,
        Verified_Flag__c: false,
      },
    ],
  },
  {
    Id: 'exp-004',
    Name: 'EXP-004198',
    CreatedDate: '2023-10-17T10:00:00Z',
    Opportunity__c: 'OPP-2024-0155 - 77 Pine Lane Rehab',
    Guarantor__c: 'Sarah Jenkins',
    Total_Experience__c: 0,
    Experience_Tier__c: '0',
    Experience_Notes__c:
      'First time borrower. No prior real estate experience documented. Co-borrower has experience.',
    Transactions_Cumulative_Sale_Price__c: null,
    Transactions_Average_Sales_Price__c: null,
    Transactions_Average_Project_Duration__c: null,
    Number_of_Flips__c: 0,
    Fix_Flip_Cumulative_Sale_Price__c: null,
    Fix_Flip_Average_Sale_Price__c: null,
    Fix_Flip_Average_Project_Duration__c: null,
    Number_of_New_Builds__c: 0,
    New_Construction_Cumulative_Sale_Price__c: null,
    New_Construction_Average_Sale_Price__c: null,
    New_Construction_Avg_Project_Duration__c: null,
    Number_of_GC_Projects__c: 0,
    Average_Rehab_Budget__c: null,
    Max_Rehab_Budget__c: null,
    Average_GC_Budget__c: null,
    Max_GC_Budget__c: null,
    Average_Construction_Budget__c: null,
    Max_Construction_Budget__c: null,
    verificationStatus: 'flagged',
    underwriterNotes:
      'Need to verify co-borrower experience. This guarantor has none.',
    individualExperiences: [],
  },
  {
    Id: 'exp-005',
    Name: 'EXP-004201',
    CreatedDate: '2023-10-17T13:20:00Z',
    Opportunity__c: 'OPP-2024-0160 - 303 Cedar St Flip',
    Guarantor__c: 'David Miller',
    Total_Experience__c: 8,
    Experience_Tier__c: '5+',
    Experience_Notes__c:
      'Steady volume of 2-3 flips per year. Consistent profitability.',
    Transactions_Cumulative_Sale_Price__c: 2400000,
    Transactions_Average_Sales_Price__c: 300000,
    Transactions_Average_Project_Duration__c: 4.5,
    Number_of_Flips__c: 8,
    Fix_Flip_Cumulative_Sale_Price__c: 2400000,
    Fix_Flip_Average_Sale_Price__c: 300000,
    Fix_Flip_Average_Project_Duration__c: 4.5,
    Number_of_New_Builds__c: 0,
    New_Construction_Cumulative_Sale_Price__c: null,
    New_Construction_Average_Sale_Price__c: null,
    New_Construction_Avg_Project_Duration__c: null,
    Number_of_GC_Projects__c: 0,
    Average_Rehab_Budget__c: 40000,
    Max_Rehab_Budget__c: 55000,
    Average_GC_Budget__c: null,
    Max_GC_Budget__c: null,
    Average_Construction_Budget__c: null,
    Max_Construction_Budget__c: null,
    verificationStatus: 'pending',
    underwriterNotes: '',
    individualExperiences: [
      {
        Id: 'iexp-005-1',
        Name: 'IEXP-004201-1',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '1010 Pine St',
          city: 'Atlanta',
          state: 'GA',
          zip: '30303',
        },
        Units__c: 1,
        Entity_Name__c: 'Miller Rehab Co',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 180000,
        Purchase_Date__c: '2021-05-15',
        Sale_Price__c: 280000,
        Sale_Date__c: '2021-10-20',
        Rehab_Amount__c: 40000,
        Net_Profit__c: 60000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-005-2',
        Name: 'IEXP-004201-2',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '2020 Oak Ave',
          city: 'Atlanta',
          state: 'GA',
          zip: '30305',
        },
        Units__c: 1,
        Entity_Name__c: 'Miller Rehab Co',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 200000,
        Purchase_Date__c: '2022-01-10',
        Sale_Price__c: 310000,
        Sale_Date__c: '2022-06-15',
        Rehab_Amount__c: 45000,
        Net_Profit__c: 65000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-005-3',
        Name: 'IEXP-004201-3',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '3030 Maple Dr',
          city: 'Atlanta',
          state: 'GA',
          zip: '30309',
        },
        Units__c: 1,
        Entity_Name__c: 'Miller Rehab Co',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 220000,
        Purchase_Date__c: '2022-08-01',
        Sale_Price__c: 330000,
        Sale_Date__c: '2023-01-20',
        Rehab_Amount__c: 50000,
        Net_Profit__c: 60000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-005-4',
        Name: 'IEXP-004201-4',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '4040 Cedar Ln',
          city: 'Atlanta',
          state: 'GA',
          zip: '30318',
        },
        Units__c: 1,
        Entity_Name__c: 'Miller Rehab Co',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 190000,
        Purchase_Date__c: '2023-02-15',
        Sale_Price__c: 300000,
        Sale_Date__c: '2023-07-30',
        Rehab_Amount__c: 45000,
        Net_Profit__c: 65000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: false,
      },
    ],
  },
  {
    Id: 'exp-006',
    Name: 'EXP-004205',
    CreatedDate: '2023-10-18T08:45:00Z',
    Opportunity__c: 'OPP-2024-0162 - 900 Elm St New Build',
    Guarantor__c: 'Elena Rodriguez',
    Total_Experience__c: 4,
    Experience_Tier__c: '3-4',
    Experience_Notes__c:
      'Architect by trade, moving into development. High quality builds.',
    Transactions_Cumulative_Sale_Price__c: 2200000,
    Transactions_Average_Sales_Price__c: 550000,
    Transactions_Average_Project_Duration__c: 9.0,
    Number_of_Flips__c: 1,
    Fix_Flip_Cumulative_Sale_Price__c: 400000,
    Fix_Flip_Average_Sale_Price__c: 400000,
    Fix_Flip_Average_Project_Duration__c: 6.0,
    Number_of_New_Builds__c: 3,
    New_Construction_Cumulative_Sale_Price__c: 1800000,
    New_Construction_Average_Sale_Price__c: 600000,
    New_Construction_Avg_Project_Duration__c: 10.0,
    Number_of_GC_Projects__c: 0,
    Average_Rehab_Budget__c: 60000,
    Max_Rehab_Budget__c: 60000,
    Average_GC_Budget__c: null,
    Max_GC_Budget__c: null,
    Average_Construction_Budget__c: 200000,
    Max_Construction_Budget__c: 250000,
    verificationStatus: 'pending',
    underwriterNotes: '',
    individualExperiences: [
      {
        Id: 'iexp-006-1',
        Name: 'IEXP-004205-1',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '123 Palm Dr',
          city: 'Miami',
          state: 'FL',
          zip: '33101',
        },
        Units__c: 1,
        Entity_Name__c: 'Rodriguez Design Build LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 250000,
        Purchase_Date__c: '2021-06-10',
        Sale_Price__c: 400000,
        Sale_Date__c: '2021-12-15',
        Rehab_Amount__c: 60000,
        Net_Profit__c: 90000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-006-2',
        Name: 'IEXP-004205-2',
        Experience_Type__c: 'New Construction',
        Property_Address__c: {
          street: '456 Ocean Blvd',
          city: 'Miami',
          state: 'FL',
          zip: '33139',
        },
        Units__c: 1,
        Entity_Name__c: 'Rodriguez Design Build LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 150000,
        Purchase_Date__c: '2022-01-20',
        Sale_Price__c: 650000,
        Sale_Date__c: '2022-11-30',
        Rehab_Amount__c: 250000,
        Net_Profit__c: 250000,
        Rehab_Flag__c: false,
        Construction_Flag__c: true,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-006-3',
        Name: 'IEXP-004205-3',
        Experience_Type__c: 'New Construction',
        Property_Address__c: {
          street: '789 Bay Rd',
          city: 'Miami',
          state: 'FL',
          zip: '33140',
        },
        Units__c: 1,
        Entity_Name__c: 'Rodriguez Design Build LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 180000,
        Purchase_Date__c: '2022-06-15',
        Sale_Price__c: 700000,
        Sale_Date__c: '2023-04-20',
        Rehab_Amount__c: 280000,
        Net_Profit__c: 240000,
        Rehab_Flag__c: false,
        Construction_Flag__c: true,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
      {
        Id: 'iexp-006-4',
        Name: 'IEXP-004205-4',
        Experience_Type__c: 'New Construction',
        Property_Address__c: {
          street: '101 Coral Way',
          city: 'Miami',
          state: 'FL',
          zip: '33145',
        },
        Units__c: 1,
        Entity_Name__c: 'Rodriguez Design Build LLC',
        Ownership_Pct__c: 100,
        Purchase_Price__c: 200000,
        Purchase_Date__c: '2023-01-10',
        Sale_Price__c: 450000,
        Sale_Date__c: null,
        Rehab_Amount__c: 200000,
        Net_Profit__c: null,
        Rehab_Flag__c: false,
        Construction_Flag__c: true,
        Status__c: 'In Progress',
        Exit_Type__c: null,
        Verified_Flag__c: false,
      },
    ],
  },
  {
    Id: 'exp-007',
    Name: 'EXP-004210',
    CreatedDate: '2023-10-18T15:10:00Z',
    Opportunity__c: 'OPP-2024-0168 - 123 Birch Rd Renovation',
    Guarantor__c: 'Thomas Wright',
    Total_Experience__c: 1,
    Experience_Tier__c: '1',
    Experience_Notes__c: 'Completed one flip in 2022. Looking to scale up.',
    Transactions_Cumulative_Sale_Price__c: 250000,
    Transactions_Average_Sales_Price__c: 250000,
    Transactions_Average_Project_Duration__c: 7.0,
    Number_of_Flips__c: 1,
    Fix_Flip_Cumulative_Sale_Price__c: 250000,
    Fix_Flip_Average_Sale_Price__c: 250000,
    Fix_Flip_Average_Project_Duration__c: 7.0,
    Number_of_New_Builds__c: 0,
    New_Construction_Cumulative_Sale_Price__c: null,
    New_Construction_Average_Sale_Price__c: null,
    New_Construction_Avg_Project_Duration__c: null,
    Number_of_GC_Projects__c: 0,
    Average_Rehab_Budget__c: 35000,
    Max_Rehab_Budget__c: 35000,
    Average_GC_Budget__c: null,
    Max_GC_Budget__c: null,
    Average_Construction_Budget__c: null,
    Max_Construction_Budget__c: null,
    verificationStatus: 'skipped',
    underwriterNotes: 'Skipped for now, waiting on credit report.',
    individualExperiences: [
      {
        Id: 'iexp-007-1',
        Name: 'IEXP-004210-1',
        Experience_Type__c: 'Fix & Flip',
        Property_Address__c: {
          street: '123 Birch Rd',
          city: 'Austin',
          state: 'TX',
          zip: '78704',
        },
        Units__c: 1,
        Entity_Name__c: null,
        Ownership_Pct__c: 100,
        Purchase_Price__c: 180000,
        Purchase_Date__c: '2022-03-15',
        Sale_Price__c: 250000,
        Sale_Date__c: '2022-10-20',
        Rehab_Amount__c: 35000,
        Net_Profit__c: 35000,
        Rehab_Flag__c: true,
        Construction_Flag__c: false,
        Status__c: 'Sold',
        Exit_Type__c: 'Sale',
        Verified_Flag__c: true,
      },
    ],
  },
]
